import React, { useState } from 'react';
import { postSolicitudAnulacionOrdenApi } from "../../../api/axios";
import { idEstadosOrden } from "../../../helper/ordenHelper";
import ModalItem from "../../General/Modal";
import { toast } from "react-toastify";

export default function SolicitudAnulacion({
  idEstado,
  idOrden,
  idSeller,
  motivoSolicitudOrden,
  motivosAnulacion = [],
  goToOrdenes,
  idMotivoAnulacion,
  setIdMotivoAnulacion,
  isSellerAdminOrIsSeller,
  orden,
}) {

  const solicitudEnviada = idEstado === idEstadosOrden.solicitarAnulacion;
  const [isUpdating, setIsUpdating] = useState(false);

  const handleMotivoAnulacion = (e) => {
    const { value } = e.target;
    setIdMotivoAnulacion(value);
  };

  const postSolicitudAnulacion = () => {
    const request = {
      idVenta: idOrden,
      idSeller: idSeller,
      solicitarAnulacion: true,
      idMotivoAnulacion: parseInt(idMotivoAnulacion)
    }

    setIsUpdating(true);
    let req = postSolicitudAnulacionOrdenApi(request);
    req.then(res => {
      toast.success("Solicitud de anulación enviada");
      goToOrdenes();
    }).catch(err => {
      toast.warning("No se pudo enviar la solicitud");
    }).finally(() => {
      setIsUpdating(false);
    });
  };

  const isValidSolicitud = () => {
    if (!idMotivoAnulacion) {
      toast.warn("Seleccione un motivo de anulación");
      return false;
    }
    return true;
  };

  const existeAnulado = orden?.estado?.some(e => e.idEstado === 5);

  /** Alineado con el botón: habilitado solo si !isUpdating && !solicitudEnviada */
  const botonSolicitarHabilitado = !isUpdating && !solicitudEnviada;
  const mostrarSelectorMotivo =
    isSellerAdminOrIsSeller && botonSolicitarHabilitado && !existeAnulado;

  if (!isSellerAdminOrIsSeller) {
    return null;
  }

  return (
    <div className="d-flex flex-wrap align-items-end column-gap-4 row-gap-2">
      <div className="flex-shrink-0">
        <ModalItem
          disabled={isUpdating || solicitudEnviada || existeAnulado}
          text={"¿Desea solicitar la anulacion de esta orden?"}
          onDelete={postSolicitudAnulacion}
          validationHandler={isValidSolicitud}
          btnStyle="btn btn-sm background-rojo-megatone"
          btnText="Solicitar Anulación"
        />
      </div>

      {mostrarSelectorMotivo && (
        <div
          className="flex-shrink-0 border-start border-secondary border-opacity-25 ps-4"
          style={{ minWidth: "220px", maxWidth: "min(100%, 300px)" }}
        >
          <label className="form-label small text-secondary mb-1">Motivo solicitud anulación</label>
          <select
            className="form-control form-control-sm"
            value={idMotivoAnulacion}
            onChange={handleMotivoAnulacion}
            disabled={isUpdating}
          >
            <option value="">Seleccione motivo</option>
            {(motivosAnulacion || []).map(motivo => (
              <option key={motivo.id} value={motivo.id}>
                {motivo.descripcion}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
